import styled from "styled-components";

export const FilterListSection = styled.section``;

// -------------------- filter ------------------------
export const FilterWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border: 1px solid #ececec;
`;

export const FilterRow = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #ececec;
  :last-of-type {
    border: none;
  }
`;

export const FilterRowTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
  padding: 10px;
  background-color: #3bb77e;
  color: #fff;

  .expand {
    flex-direction: column;
  }
`;

export const FilterRowList = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & li {
    display: flex;
    align-items: center;
    padding: 10px;
    position: relative;
    & a {
      color: #121212;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0px 10px;
      :hover {
        text-decoration: underline !important;
      }
    }
    .active {
      background-color: #3bb77e;
      color: #fff;
      border-radius: 10px;
    }
    & span {
      display: none;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      position: absolute;
      top: 0px;
      right: 0px;
      background-color: #fff;
      box-shadow: 0px 1px 1px #12121259;
      color: #253d4e;
      height: 15px;
      width: 15px;
      font-size: 8px;
      padding: 8px;
      border: 1px solid #ececec;
      margin: 0px;
      & i {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    :hover {
      & span {
        display: flex;
      }
    }
  }
`;

export const FilteredListWrapper = styled.div`
  display: flex;
  align-items: center;
  .all {
    min-width: 160px;
    border-right: 1px solid #ececec;
    display: flex;
    align-items: center;
    justify-content: center;

    & a {
      display: flex;
      align-items: center;
      padding: 10px;
      cursor: pointer;

      & i {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
      }
      :hover {
        color: #3bb77e;
      }
    }
  }
`;

export const CheckedFilters = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  & li {
    display: flex;
    align-items: center;

    & a {
      color: #3bb77e !important;
      font-weight: 500;
      position: relative;
      padding: 5px 10px;

      ::after {
        margin: 0px 5px;
        content: "X";
      }
    }
  }
`;

// -------------------- list ------------------------
export const ListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  border-top: 2px solid #121212;
  border-bottom: 2px solid #121212;
`;

export const ListSortWrapper = styled.div`
  padding: 10px 0px;
  border-bottom: 1px solid #ececec;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListViewTypeWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ListViewSelectBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border: 1px solid #ececec;
    cursor: pointer;
  }

  .selected {
    background-color: #3bb77e;
    color: white;
    border: 1px solid #3bb77e;
  }
`;

export const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
`;

export const ProductsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) =>
    props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)"};
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ProductsSignWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;
  margin-top: 50px;
  & h4 {
    margin-bottom: 20px;
    text-align: center;
  }
`;

// table type list
export const TableTypeWrapper = styled.div`
  display: flex;
`;

export const Table = styled.table`
  color: #253d4e;
  .header {
    background-color: #f9f6f6ba;
  }
  & tr {
    text-align: center;
    :hover {
      background-color: #f9f6f6ba;
    }
  }

  & th {
    padding: 5px;
    font-size: 14px;
    word-break: keep-all;
  }

  & td {
    padding: 10px;
  }

  & a {
    color: #253d4e;
  }

  .img {
    width: 10%;
    padding: 5px;
    & a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .name {
    width: 15%;
    & a {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      word-break: keep-all;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .price {
    color: #dc3545;
  }

  .btnWrapper {
    width: 15%;
  }

  @media (max-width: 991px) {
    & td {
      padding: 5px;
    }
    .name {
    }
    .golgi {
      width: 7%;
    }
    .feature {
      width: 15%;
    }
    .sizes {
      width: 10%;
    }
    .onePrice {
      width: 10%;
    }
    .quantity {
      width: 10%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 767px) {
    & th {
      font-size: 12px;
    }
    & td {
      font-size: 12px;
    }
    .img {
      display: none;
    }
    .golgi {
      width: 7%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 575px) {
    & th {
      font-size: 10px;
    }
    & td {
      font-size: 10px;
      padding: 5px;
    }
    .name {
      width: 25%;
    }
    .sizes {
      display: none;
    }
    .strength {
      width: 10%;
    }
    .feature {
      width: 10%;
    }
    .golgi {
    }
    .onePrice {
    }
    .quantity {
    }
    .price {
    }
  }
  @media (max-width: 460px) {
    .quantity {
      display: none;
    }
    .onePrice {
      display: none;
    }
  }
`;
